const indexItems = [
  {
    title: '热播电视剧合集',
    desc: '最新上线的热门电视剧一网打尽',
    icon: 'ri-tv-2-line',
    count: '42部',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '最新电影专区',
    desc: '院线下线新片抢先看',
    icon: 'ri-film-line',
    count: '67部',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    title: '古装剧精选',
    desc: '品质古装大剧一次看够',
    icon: 'ri-building-2-line',
    count: '28部',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    title: '都市情感剧场',
    desc: '现实主义题材温暖呈现',
    icon: 'ri-heart-2-line',
    count: '35部',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '悬疑推理馆',
    desc: '烧脑剧情全程高能',
    icon: 'ri-search-eye-line',
    count: '23部',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    title: '美食纪录片',
    desc: '下饭必备内容精选',
    icon: 'ri-bowl-line',
    count: '31部',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    title: '动作冒险大片',
    desc: '荷尔蒙爆棚的视听盛宴',
    icon: 'ri-rocket-2-line',
    count: '19部',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              内容专题索引
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              按分类快速找到你想看的内容，追剧不迷路
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.map((item, idx) => (
              <div
                key={idx}
                className={`group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                  idx === 6 ? 'lg:col-start-2' : ''
                }`}
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mb-3">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-arrow-right-line"></i>
                  共 {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}